import { LitElement, html } from 'lit';
import '../icons/info-icon.js';

class QuoteNotFound extends LitElement {
    static properties = {
        quoteReference: { type: String },
    };

    createRenderRoot() {
        return this; // Light DOM for Tailwind compatibility
    }

    constructor() {
        super();
        this.quoteReference = '';
    }

    _navigateToLanding() {
        // Preserve the invalid reference in query parameter
        window.location.hash = `/#?ref=${encodeURIComponent(this.quoteReference)}`;
    }

    render() {
        return html`
            <div class="hero min-h-[50vh] bg-base-200 rounded-lg">
                <div class="hero-content text-center">
                    <div class="max-w-lg">
                        <h1 class="text-3xl font-bold mb-4">Quote Not Found</h1>
                        <p class="mb-6">
                            We couldn't find a quote with reference
                            <strong class="text-error">${this.quoteReference}</strong>.
                        </p>
                        <div class="alert alert-row alert-info mb-6">
                            <info-icon class="shrink-0"></info-icon>
                            <span class="text-sm text-left">
                                Your quote reference can be found in the email we sent you. Please
                                check your inbox and try again.
                            </span>
                        </div>
                        <div class="flex gap-3 justify-center flex-wrap">
                            <button @click="${this._navigateToLanding}" class="btn btn-primary">
                                Enter Different Reference
                            </button>
                            <a
                                href="mailto:info@reach.nz?subject=Quote%20Acceptance:%20Quote%20Not%20Found%20-%20${this
                                    .quoteReference}"
                                class="btn btn-outline"
                            >
                                Contact Support
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('quote-not-found', QuoteNotFound);
